import { lazy, Suspense } from 'react';
import type { ViewHighlightsModalProps } from './ViewHighlightsModal';

const ViewHighlightsModal = lazy(() => import('./ViewHighlightsModal'));

const ViewHighlightsModalLazy = (props: ViewHighlightsModalProps) => {
    if (!props.show) return null;

    return (
        <Suspense fallback={null}>
            <ViewHighlightsModal {...props} />
        </Suspense>
    );
};

export default ViewHighlightsModalLazy;
